import React from 'react';

export default ({ color = '#525979', size = 17 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 0.708008L14.3203 2.00141C14.6444 2.07343 14.875 2.36088 14.875 2.69288V9.76681C14.875 11.1878 14.1648 12.5148 12.9825 13.303L8.5 16.2913L4.01753 13.303C2.83518 12.5148 2.125 11.1878 2.125 9.76681V2.69288C2.125 2.36088 2.35558 2.07343 2.67967 2.00141L8.5 0.708008ZM8.5 2.15923L3.54167 3.26108V9.76681C3.54167 10.7141 4.01512 11.5988 4.80335 12.1243L8.5 14.5887L12.1966 12.1243C12.9849 11.5988 13.4583 10.7141 13.4583 9.76681V3.26108L8.5 2.15923ZM11.6538 5.82347L12.6555 6.8252L8.14767 11.333L5.14249 8.32783L6.14423 7.32604L8.14718 9.32906L11.6538 5.82347Z"
      fill={color}
    />
  </svg>
);
